(function () {
    const MENSAJES_CARGA = {
        editarReserva: [
            "Actualizando reserva y enviando correspondencia",
            "El correo puede tardar unos segundos en ser procesado.",
        ],
        modificarReservar: [
            "Actualizando reserva",
            "Estamos guardando tus cambios.",
        ],
        editarImpo: [
            "Actualizando importación y enviando correspondencia",
            "Estamos guardando los cambios y notificando a los usuarios.",
        ],
        importExcelImportaciones: [
            "Procesando archivo de importaciones",
            "Estamos validando e importando la información del archivo.",
        ],
        importExcelMercancia: [
            "Procesando archivo de mercancía",
            "Estamos validando e importando la información del archivo.",
        ],
        excelImpo: ["Generando archivo Excel", "Preparando la información para descargar."],
        excelMerc: ["Generando archivo Excel", "Preparando la información para descargar."],
        excelDetalleImpo: ["Generando archivo Excel", "Preparando la información para descargar."],
        excelPanelAutorizacion: ["Generando archivo Excel", "Aplicando los filtros del panel y preparando la descarga."],
    };
    const ACCIONES_SIN_RESET = new Set([
        "editarImpo",
        "vaciarImpo",
        "editarMercancia",
        "modificarReservar",
        "editarReserva",
    ]);

    function contenedorAlertas() {
        let contenedor = document.querySelector(".cont-alertas");
        if (!contenedor) {
            contenedor = document.createElement("div");
            contenedor.className = "cont-alertas";
            contenedor.setAttribute("aria-live", "polite");
            document.body.appendChild(contenedor);
        }
        return contenedor;
    }

    function notificar(mensaje, tipo = "exito") {
        const contenedor = contenedorAlertas();
        const alerta = document.createElement("div");
        alerta.className = tipo === "error" ? "alerta-roja" : "alerta-verde";

        const icono = document.createElement("img");
        icono.className = "svg-alerta";
        icono.src = "/public/build/img/icons/alerta.svg";
        icono.alt = "";

        const texto = document.createElement("span");
        texto.className = "span-msg";
        texto.textContent = mensaje;

        const cerrar = document.createElement("button");
        cerrar.type = "button";
        cerrar.className = "btn-cerrar";
        cerrar.setAttribute("aria-label", "Cerrar alerta");
        cerrar.innerHTML = '<img class="svg-cerrar" src="/public/build/img/icons/x.svg" alt="">';
        cerrar.addEventListener("click", () => alerta.remove());

        alerta.append(icono, texto, cerrar);
        contenedor.appendChild(alerta);
        contenedor.classList.add("show--alert");

        window.setTimeout(() => {
            alerta.remove();
            if (!contenedor.children.length) contenedor.classList.remove("show--alert");
        }, 7000);
    }

    function limpiarErrores(formulario) {
        formulario.querySelectorAll(".imputRojo").forEach((campo) => campo.classList.remove("imputRojo"));
    }

    function marcarErrores(formulario, campos) {
        const alias = {
            reserva: "solicitud_reserva",
            cantidad: "reserva_autorizada",
            idMercancia: "id_mercancia",
        };
        let primero = null;
        (campos || []).forEach((campo) => {
            const nombre = alias[campo] || campo;
            const elemento = formulario.querySelector(`[name="${CSS.escape(nombre)}"], #${CSS.escape(campo)}`);
            if (!elemento) return;
            elemento.classList.add("imputRojo");
            if (!primero && !elemento.disabled && elemento.type !== "hidden") primero = elemento;
        });
        if (primero) primero.focus();
    }

    function mostrarErroresImportacion(html) {
        if (!html) return;
        const modal = document.querySelector(".modalTablaErroresImpo");
        const tabla = modal && modal.querySelector(".tabla-errorImpo");
        if (!modal || !tabla) return;
        const cuerpoAnterior = tabla.querySelector("tbody");
        if (cuerpoAnterior) cuerpoAnterior.remove();
        tabla.insertAdjacentHTML("beforeend", html);
        modal.classList.add("modal--show");
        document.body.classList.add("no-scroll");
    }

    function cerrarModal(formulario) {
        const modal = formulario.closest(".modal");
        if (!modal) return;
        modal.classList.remove("modal--show");
        if (!document.querySelector(".modal.modal--show")) {
            document.body.classList.remove("no-scroll");
        }
    }

    function actualizarResumenImportacion(importacion) {
        if (!importacion) return;
        Object.entries(importacion).forEach(([campo, valor]) => {
            const elemento = document.querySelector(`[data-importacion-campo="${CSS.escape(campo)}"]`);
            if (elemento) elemento.textContent = valor || "";
        });
    }

    function nombreArchivo(respuesta) {
        const disposicion = respuesta.headers.get("Content-Disposition") || "";
        const coincidencia = disposicion.match(/filename\*?=(?:UTF-8''|["'])?([^"';]+)["']?/i);
        return coincidencia ? decodeURIComponent(coincidencia[1].trim()) : "descarga";
    }

    async function descargarRespuesta(respuesta) {
        const blob = await respuesta.blob();
        const url = URL.createObjectURL(blob);
        const enlace = document.createElement("a");
        enlace.href = url;
        enlace.download = nombreArchivo(respuesta);
        document.body.appendChild(enlace);
        enlace.click();
        enlace.remove();
        window.setTimeout(() => URL.revokeObjectURL(url), 1000);
        notificar("La descarga se generó correctamente.");
    }

    function datosFormulario(formulario, submitter) {
        const datos = new FormData(formulario);
        if (submitter && submitter.name && submitter.value) {
            datos.set(submitter.name, submitter.value);
        }
        const idImpo = new URLSearchParams(window.location.search).get("id-impo");
        if (idImpo && !datos.has("contexto_id_impo")) datos.append("contexto_id_impo", idImpo);
        return datos;
    }

    document.addEventListener("submit", async (evento) => {
        const formulario = evento.target;
        if (!(formulario instanceof HTMLFormElement)) return;
        if (String(formulario.method).toLowerCase() !== "post" || formulario.dataset.postNativo === "true") return;

        evento.preventDefault();
        if (formulario.getAttribute("aria-busy") === "true") return;

        const submitter = evento.submitter;
        const datos = datosFormulario(formulario, submitter);
        const accion = String(datos.get("accion") || "");
        const esLogin = formulario.classList.contains("login") || window.location.pathname === "/login";
        const endpoint = esLogin ? "/api/login" : "/api/actions";
        const mensaje = MENSAJES_CARGA[accion] || ["Procesando solicitud", "Espera un momento, por favor."];

        limpiarErrores(formulario);
        formulario.setAttribute("aria-busy", "true");
        if (submitter) submitter.disabled = true;

        try {
            const respuesta = await fetch(endpoint, {
                method: "POST",
                credentials: "include",
                headers: { "Accept": "application/json" },
                body: datos,
                mensajeCargando: mensaje[0],
                detalleCargando: mensaje[1],
                bloquearSalida: true,
            });

            const tipoContenido = respuesta.headers.get("Content-Type") || "";
            if (!tipoContenido.includes("application/json")) {
                if (!respuesta.ok) throw new Error("No fue posible generar la descarga.");
                await descargarRespuesta(respuesta);
                return;
            }

            const cuerpo = await respuesta.json();
            if (respuesta.status === 401) {
                window.location.assign("/login");
                return;
            }

            if (!respuesta.ok || !cuerpo.success) {
                const errores = (cuerpo.errors || []).map((error) => error.message);
                (errores.length ? errores : ["No fue posible completar la solicitud."])
                    .forEach((error) => notificar(error, "error"));
                marcarErrores(formulario, cuerpo.result && cuerpo.result.fieldErrors);
                mostrarErroresImportacion(cuerpo.result && cuerpo.result.tableErrorsHtml);
                return;
            }

            const resultado = cuerpo.result || {};
            (resultado.messages || ["La solicitud se completó correctamente."])
                .forEach((texto) => notificar(texto));

            actualizarResumenImportacion(resultado.importacion);
            mostrarErroresImportacion(resultado.tableErrorsHtml);

            if (resultado.redirect) {
                window.location.assign(resultado.redirect);
                return;
            }

            cerrarModal(formulario);
            if (!ACCIONES_SIN_RESET.has(resultado.action)) formulario.reset();
            window.dispatchEvent(new CustomEvent("spray:datos-actualizados", {
                detail: { action: resultado.action },
            }));
        } catch (error) {
            console.error("Error en solicitud POST:", error);
            notificar(error.message || "Ocurrió un error de conexión. Inténtalo nuevamente.", "error");
        } finally {
            formulario.removeAttribute("aria-busy");
            if (submitter) submitter.disabled = false;
        }
    });
})();
